var componentRequireContext = require.context("components", true, /front\/inquiry\/*/);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
